import { IconButton, Tooltip, useColorScheme } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';

/**
 * Light/dark mode toggle. Persists via MUI useColorScheme (localStorage).
 * Resolves "system" to the actual scheme so the icon always reflects reality.
 */
const ColorModeToggle = ({ size = 'small', sx }) => {
  const { mode, systemMode, setMode } = useColorScheme();
  const resolved = mode === 'system' ? systemMode : mode;
  const isDark = resolved === 'dark';

  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton
        size={size}
        onClick={() => setMode(isDark ? 'light' : 'dark')}
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        sx={{
          color: 'text.secondary',
          transition: 'color 0.15s ease, transform 0.2s ease',
          '&:hover': { color: 'text.primary', transform: 'rotate(15deg)' },
          ...sx,
        }}
      >
        {isDark ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
};

export default ColorModeToggle;
